<template>
  <div class="wrapper">
    <!-- <header class="header" data-title="검색"></header> -->
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="search">
        <div class="searchWrap">
          <button type="button" class="btnIco_back" @click="$router.go(-1)"><span>이전페이지</span></button>
          <input
            type="text"
            id="searchWord"
            name="searchWord"
            v-model="searchWord"
            class="ipt"
            placeholder="검색어를 입력해주세요"
            title="검색어 입력"
            value=""
            @keyup="inputEnter"
          />
          <button type="button" class="btnIco_srch" @click="search"><span>검색</span></button>
        </div>

        <div class="tabWrap">
          <ul class="tabList pageTab">
            <li class="on">최근검색어</li>
            <li class="popular">인기검색어</li>
            <li>추천검색어</li>
          </ul>

          <div class="tabContents">
            <div class="tabPanel">
              <section class="hr pt15" v-if="searchHistory.length > 0">
                <div class="srchTop">
                  <p class="delAll"><button type="button" @click="delAll">전체삭제</button></p>
                </div>
                <ul class="srchList">
                  <li v-for="(history, index) in searchHistory.slice().reverse()" :key="index">
                    <a>
                      <span class="keyword" @click="$router.push('/search/' + history.searchWord)">{{ history.searchWord }}</span>
                      <span class="date">{{ history.searchDate }}</span>
                    </a>
                    <button type="button" class="delete" @click="del(index)"><span class="blind">삭제</span></button>
                  </li>
                </ul>
              </section>
              <section v-else>
                <div class="resultMsg txtOnly">
                  <p class="copy">최근 검색어가 없습니다.</p>
                </div>
              </section>
            </div>
            <div class="tabPanel">
              <section class="hr pt15">
                <div class="srchTop">
                  <p class="txtS" v-if="userInfo && (personalInfo.ageNm != '' || personalInfo.sexNm != '')">
                    #
                    <span v-if="personalInfo.ageNm != ''">{{ personalInfo.ageNm }}</span>
                    <span v-if="personalInfo.sexNm != ''">{{ personalInfo.sexNm }}의</span>
                    인기검색어
                  </p>
                  <p class="txtS" v-else>
                    이 상품이 가장 인기 있어요.
                  </p>
                </div>

                <ul class="srchList rank">
                  <li v-for="(popularSearch, index) in popularSearchList" :key="index">
                    <a>
                      <span class="num">{{ popularSearch.id.rank }}</span>
                      <span class="keyword" @click="$router.push('/search/' + popularSearch.srchNm)">{{ popularSearch.srchNm }}</span>
                      <span v-if="popularSearch.varCd === 'SCH20001'" class="rank up"></span>
                      <span v-else-if="popularSearch.varCd === 'SCH20002'" class="rank down"></span>
                      <span v-else-if="popularSearch.varCd === 'SCH20004'" class="rank new">NEW</span>
                    </a>
                  </li>
                </ul>
              </section>
            </div>
            <div class="tabPanel">
              <section class="hr pt15">
                <ul class="srchList rank">
                  <li v-for="(recomSearch, index) in recomSearchList" :key="index">
                    <a>
                      <span class="num">{{ recomSearch.id.rank }}</span>
                      <span class="keyword pointC4" @click="$router.push('/search/' + recomSearch.srchNm)">{{ recomSearch.srchNm }}</span>
                    </a>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
      <!-- content(e) -->
      <MessagePop v-if="messagePop" @close="messagePop = false">
        <p v-html="msg"></p>
      </MessagePop>
    </div>
    <!-- container(e) -->
    <QuickMenu></QuickMenu>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import * as customjs from '@/../static/js/m.front.js';
import JwtService from '@/common/jwt.service';
import ApiService from '@/common/api.service';
import QuickMenu from '@/views/app/comm/QuickMenu';
import { isEmpty } from '@/common/common.function.js';
import MessagePop from '@/components/popup/MessagePop';
import { INPUT_KEYWORD } from '@/store/message.type.js';

export default {
  name: 'searchKeyword',
  components: {
    QuickMenu,
    MessagePop,
  },
  data: function() {
    return {
      headerTitle: '검색',
      userInfo: JwtService.getUserInfo(),
      popularSearchList: [],
      recomSearchList: [],
      searchWord: '',
      searchHistory: [],
      personalInfo: '',

      msg: null,
      messagePop: null,
    };
  },
  mounted() {
    // 최근검색어
    let obj = JSON.parse(localStorage.getItem('searchHistory'));
    if (!isEmpty(obj)) this.searchHistory = obj;

    // 인기검색어
    ApiService.service('GET', '/product/search/SCH10001')
      .then(({ data }) => {
        console.log(data);
        this.popularSearchList = data.result;
      })
      .catch(({ response }) => {
        console.log(response);
      });

    // 추천검색어
    ApiService.service('GET', '/product/search/SCH10002')
      .then(({ data }) => {
        // console.log(data);
        this.recomSearchList = data.result;
      })
      .catch(({ response }) => {
        console.log(response);
      });

    // 개인화 정보
    ApiService.service('GET', '/user/getPersonalInfo')
      .then(({ data }) => {
        this.personalInfo = data.result;
      })
      .catch(({ response }) => {
        console.log(response);
      });

    // TODO header 가 없어서 우선 적용
    customjs.init();

    if (this.searchHistory.length == 0) {
      document.getElementsByClassName('popular')[0].click();
    }
  },
  methods: {
    search() {
      if (!isEmpty(this.searchWord)) {
        // 최근검색어 저장 TODO 서버시간
        /*let today = new Date();
          let history = {
            searchWord: this.searchWord,
            searchDate: today.getMonth() + 1 + '.' + today.getDate(),
          };
          this.searchHistory.push(history);
          localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));*/
        this.$router.push('/search/' + this.searchWord);
      } else {
        this.msg = INPUT_KEYWORD;
        this.messagePop = true;
      }
    },
    del(index) {
      let len = this.searchHistory.length;
      let idx = len - (index + 1);
      this.searchHistory.splice(idx, 1);
      localStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));
    },
    delAll() {
      localStorage.removeItem('searchHistory');
      this.searchHistory = [];
    },
    getAge(birthDate) {
      let birthYear = Number(birthDate.substring(0, 4));
      let todayYear = Number(new Date().getFullYear());
      let age = todayYear - birthYear;

      return Math.round(age / 10) * 10;
    },
    // TODO 테스트 용
    inputEnter() {
      if (window.event.keyCode == 13) {
        this.$router.push('/search/' + this.searchWord);
      }
    },
  },
};
</script>
